import { Form, Row, Col } from 'react-bootstrap';

const PersonalDetailsForm = ({ data, onChange, errors, formData }) => {
  const handleChange = (field, value) => {
    onChange('personal', field, value);
  };

  const handleAddressChange = (addressType, field, value) => {
    onChange('personal', addressType, {
      ...formData.personal[addressType],
      [field]: value
    });
  };

  const handleEmergencyContactChange = (field, value) => {
    onChange('personal', 'emergencyContact', {
      ...formData.personal.emergencyContact,
      [field]: value
    });
  };

  const handleSameAsCurrentAddress = (e) => {
    if (e.target.checked) {
      onChange('personal', 'permanentAddress', { ...formData.personal.currentAddress });
    }
  };

  return (
    <div>
      <h5 className="mb-3">Personal Details</h5>
      
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>First Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              value={data.firstName}
              onChange={(e) => handleChange('firstName', e.target.value)}
              isInvalid={!!errors.firstName}
            />
            <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Middle Name</Form.Label>
            <Form.Control
              type="text"
              value={data.middleName}
              onChange={(e) => handleChange('middleName', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Last Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              value={data.lastName}
              onChange={(e) => handleChange('lastName', e.target.value)}
              isInvalid={!!errors.lastName}
            />
            <Form.Control.Feedback type="invalid">{errors.lastName}</Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Email <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="email"
              value={data.email}
              onChange={(e) => handleChange('email', e.target.value)}
              isInvalid={!!errors.email}
            />
            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Phone <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="tel"
              value={data.phone}
              onChange={(e) => handleChange('phone', e.target.value)}
              isInvalid={!!errors.phone}
            />
            <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Date of Birth <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="date"
              value={data.dateOfBirth}
              onChange={(e) => handleChange('dateOfBirth', e.target.value)}
              isInvalid={!!errors.dateOfBirth}
            />
            <Form.Control.Feedback type="invalid">{errors.dateOfBirth}</Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Gender</Form.Label>
            <Form.Select
              value={data.gender}
              onChange={(e) => handleChange('gender', e.target.value)}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Marital Status</Form.Label>
            <Form.Select
              value={data.maritalStatus}
              onChange={(e) => handleChange('maritalStatus', e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Blood Group</Form.Label>
            <Form.Select
              value={data.bloodGroup}
              onChange={(e) => handleChange('bloodGroup', e.target.value)}
            >
              <option value="">Select Blood Group</option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Aadhaar Card Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="12-digit Aadhaar Number"
              value={data.aadhaarNumber || ''}
              onChange={(e) => handleChange('aadhaarNumber', e.target.value)}
              maxLength={12}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>PAN Card Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="10-digit PAN Number"
              value={data.panNumber || ''}
              onChange={(e) => handleChange('panNumber', e.target.value)}
              className="text-uppercase"
              maxLength={10}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Aadhaar Card Scan (Image/PDF)</Form.Label>
            {data.aadhaarScan && typeof data.aadhaarScan === 'string' && (
              <div className="mb-2">
                <small className="text-success d-block mb-1">File already uploaded</small>
                {data.aadhaarScan.startsWith('data:image') && (
                  <img src={data.aadhaarScan} alt="Aadhaar Preview" style={{ height: '40px', marginRight: '10px', borderRadius: '4px' }} />
                )}
                <a href={data.aadhaarScan} target="_blank" rel="noopener noreferrer" className="btn btn-xs btn-link p-0 text-decoration-none">
                  View current scan
                </a>
              </div>
            )}
            <Form.Control
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) handleChange('aadhaarScan', file);
              }}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>PAN Card Scan (Image/PDF)</Form.Label>
            {data.panScan && typeof data.panScan === 'string' && (
              <div className="mb-2">
                <small className="text-success d-block mb-1">File already uploaded</small>
                {data.panScan.startsWith('data:image') && (
                  <img src={data.panScan} alt="PAN Preview" style={{ height: '40px', marginRight: '10px', borderRadius: '4px' }} />
                )}
                <a href={data.panScan} target="_blank" rel="noopener noreferrer" className="btn btn-xs btn-link p-0 text-decoration-none">
                  View current scan
                </a>
              </div>
            )}
            <Form.Control
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) handleChange('panScan', file);
              }}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Profile Photo</Form.Label>
            {data.photo && typeof data.photo === 'string' && (
              <div className="mb-2">
                <small className="text-success d-block mb-1">Photo already uploaded</small>
                {data.photo.startsWith('data:image') && (
                  <img src={data.photo} alt="Photo Preview" style={{ height: '40px', width: '40px', objectFit: 'cover', marginRight: '10px', borderRadius: '50%' }} />
                )}
                <a href={data.photo} target="_blank" rel="noopener noreferrer" className="btn btn-xs btn-link p-0 text-decoration-none">
                  View current photo
                </a>
              </div>
            )}
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) handleChange('photo', file);
              }}
            />
          </Form.Group>
        </Col>
      </Row>

      <h6 className="mt-4 mb-3">Current Address</h6>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Address Line 1</Form.Label>
            <Form.Control
              type="text"
              value={data.currentAddress?.line1}
              onChange={(e) => handleAddressChange('currentAddress', 'line1', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Address Line 2</Form.Label>
            <Form.Control
              type="text"
              value={data.currentAddress?.line2}
              onChange={(e) => handleAddressChange('currentAddress', 'line2', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Form.Group>
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              value={data.currentAddress?.city}
              onChange={(e) => handleAddressChange('currentAddress', 'city', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>State</Form.Label>
            <Form.Control
              type="text"
              value={data.currentAddress?.state}
              onChange={(e) => handleAddressChange('currentAddress', 'state', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Pincode</Form.Label>
            <Form.Control
              type="text"
              value={data.currentAddress?.pincode}
              onChange={(e) => handleAddressChange('currentAddress', 'pincode', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Country</Form.Label>
            <Form.Control
              type="text"
              value={data.currentAddress?.country}
              onChange={(e) => handleAddressChange('currentAddress', 'country', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <h6 className="mt-4 mb-3">Permanent Address</h6>
      <Form.Check
        type="checkbox"
        label="Same as Current Address"
        className="mb-3"
        onChange={handleSameAsCurrentAddress}
      />

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Address Line 1</Form.Label>
            <Form.Control
              type="text"
              value={data.permanentAddress?.line1}
              onChange={(e) => handleAddressChange('permanentAddress', 'line1', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Address Line 2</Form.Label>
            <Form.Control
              type="text"
              value={data.permanentAddress?.line2}
              onChange={(e) => handleAddressChange('permanentAddress', 'line2', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Form.Group>
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              value={data.permanentAddress?.city}
              onChange={(e) => handleAddressChange('permanentAddress', 'city', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>State</Form.Label>
            <Form.Control
              type="text"
              value={data.permanentAddress?.state}
              onChange={(e) => handleAddressChange('permanentAddress', 'state', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Pincode</Form.Label>
            <Form.Control
              type="text"
              value={data.permanentAddress?.pincode}
              onChange={(e) => handleAddressChange('permanentAddress', 'pincode', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>Country</Form.Label>
            <Form.Control
              type="text"
              value={data.permanentAddress?.country}
              onChange={(e) => handleAddressChange('permanentAddress', 'country', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <h6 className="mt-4 mb-3">Emergency Contact</h6>
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Contact Name</Form.Label>
            <Form.Control
              type="text"
              value={data.emergencyContact?.name}
              onChange={(e) => handleEmergencyContactChange('name', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Relation</Form.Label>
            <Form.Control
              type="text"
              value={data.emergencyContact?.relation}
              onChange={(e) => handleEmergencyContactChange('relation', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="tel"
              value={data.emergencyContact?.phone}
              onChange={(e) => handleEmergencyContactChange('phone', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default PersonalDetailsForm;
